// extracted by mini-css-extract-plugin
export default {"box":"_FiCc_OeBN4yJ42IdBn_","text":"kolA00ublIPmeiSbeI7p"};